import React, { Component } from "react";
import SearchResult from "../components/searchPage/searchResult";
import Header from "../components/Header.js";
import Sidebar from "../components/Sidebar";
import MainContainer from "../components/MainContainer";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import SearchFilter from "../components/searchPage/SearchFilter";
import FilterListIcon from "@material-ui/icons/FilterList";
import Loading from "../components/loadingSpinner/Loading";
import { inject, observer } from "mobx-react";
import { ProfileType } from "../types/enum";
import "./SearchPage.css";

@inject("searchStore")
@observer
class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchFilterShowed: true
        };
    }

    toggleSearchFilter = () => {
        this.setState({
            ...this.state,
            searchFilterShowed: !this.state.searchFilterShowed
        });
    };

    handleSortChange = (e) => {
        this.props.searchStore.setSortBy(e.target.value);
        this.props.searchStore.submitSearch();
    };

    handleTypeTabChange = (type) => {
        this.props.searchStore.setType(type);
        this.props.searchStore.submitSearch();
    };

    render() {
        const { isLoading, type, sortBy, results, newActsWeeks } = this.props.searchStore;
        const { searchFilterShowed } = this.state;

        const profileTabs = [
            { label: "Act / Band", value: ProfileType.Act.ordinal },
            { label: "Musician", value: ProfileType.Musician.ordinal },
            { label: "Venue", value: ProfileType.Venue.ordinal },
            { label: "Agent", value: ProfileType.Agent.ordinal }
        ];

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <div className="search-page-header">
                        <h1 className="search-page-title">Connect (Search)</h1>
                        <div className="search-header-actions">
                            <Button 
                                className={`filter-toggle-btn ${searchFilterShowed ? 'active' : ''}`}
                                onClick={this.toggleSearchFilter}
                            >
                                <FilterListIcon /> Filters
                            </Button>
                        </div>
                    </div>

                    <div className="profile-type-tabs">
                        {profileTabs.map(tab => (
                            <button
                                key={tab.value}
                                className={`profile-tab ${type === tab.value ? 'active' : ''}`}
                                onClick={() => this.handleTypeTabChange(tab.value)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {searchFilterShowed ? (
                        <Grid container style={{ marginBottom: 24 }}>
                            <Grid item xs={12} lg={12}>
                                <SearchFilter hideHeader={true} />
                            </Grid>
                        </Grid>
                    ) : null}

                    <div className="results-bar">
                        <span className="results-count">Showing {results?.length || 0} results</span>
                        <div className="results-bar-right">
                            <div className="active-filters">
                                {newActsWeeks && (
                                    <span className="filter-chip">New acts: last {newActsWeeks} weeks</span>
                                )}
                            </div>
                            <FormControl className="sort-dropdown-results">
                                <Select
                                    value={sortBy || ""}
                                    onChange={this.handleSortChange}
                                    displayEmpty
                                    disableUnderline
                                >
                                    <MenuItem value="">Sort by: Relevance</MenuItem>
                                    <MenuItem value="gigs_desc">Most Gigs Played</MenuItem>
                                    <MenuItem value="gigs_asc">Least Gigs Played</MenuItem>
                                    <MenuItem value="recent">Recently Added</MenuItem>
                                    <MenuItem value="hours_desc">Most Hours Played</MenuItem>
                                    <MenuItem value="name_asc">Name A-Z</MenuItem>
                                    <MenuItem value="name_desc">Name Z-A</MenuItem>
                                    <MenuItem value="distance">Distance (Nearest)</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    <Grid container spacing={8}>
                        <Grid item xs={12} lg={12} style={{ position: "relative", minHeight: 400 }}>
                            <Loading showed={isLoading} />
                            <SearchResult />
                        </Grid>
                    </Grid>
                </MainContainer>
            </main>
        );
    }
}

export default SearchPage;
